const searchDisclosure = document.querySelector('[data-op6-search]');
if (searchDisclosure) {
  const header = searchDisclosure.closest('.op4-header');
  const trigger = searchDisclosure.querySelector('summary');
  const form = searchDisclosure.querySelector('form');
  const input = form?.querySelector('input[type="search"]');
  const results = searchDisclosure.querySelector('[data-op6-search-results]');
  const status = results?.querySelector('[data-op6-search-status]');
  const list = results?.querySelector('[data-op6-search-list]');
  const allowed = new Set(['op-r1-home', 'op-r1-pet', 'op-r1-family', 'op-r1-women', 'op-r1-celebration', 'op-r1-gift', 'op-r1-wedding', 'stop-chasing-the-maybe', 'the-magnetic-shift', '20-secrets-of-the-master-lover', 'unapologetic-lust', 'the-chemistry-code', 'after-dark', 'the-height-guide']);
  let request;
  let timer;
  let generation = 0;

  function clearResults() {
    results.hidden = true;
    list.replaceChildren();
    status.textContent = '';
  }
  function close() {
    searchDisclosure.open = false;
    trigger.focus({preventScroll: true});
  }
  function show(products, query) {
    list.replaceChildren();
    for (const product of products) {
      const url = new URL(product.url, location.origin);
      const handle = url.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([a-z0-9-]+)\/?$/i)?.[1];
      if (url.origin !== location.origin || !allowed.has(handle)) continue;
      const item = document.createElement('li');
      const link = document.createElement('a');
      const title = document.createElement('span');
      const arrow = document.createElement('span');
      title.textContent = product.title;
      arrow.textContent = '→';
      arrow.setAttribute('aria-hidden', 'true');
      link.href = url.pathname;
      link.append(title, arrow);
      item.append(link);
      list.append(item);
    }
    const count = list.childElementCount;
    status.textContent = count ? `${count} matching ${count === 1 ? 'product' : 'products'} for “${query}”` : `No products found for “${query}”`;
    if (!count) {
      const empty = document.createElement('li');
      empty.className = 'op6-search-empty';
      empty.textContent = 'Try Magnetic Shift, Height Guide, home, pet, or wedding.';
      list.append(empty);
    }
    results.hidden = false;
  }
  async function search() {
    const query = input.value.trim();
    request?.abort();
    const current = ++generation;
    if (!query) { clearResults(); return; }
    request = new AbortController();
    status.textContent = 'Searching the library…';
    results.hidden = false;
    list.replaceChildren();
    try {
      const url = new URL(form.action);
      url.pathname = url.pathname.replace(/\/search\/?$/, '/search/suggest.json');
      url.search = new URLSearchParams({'q':query, 'resources[type]':'product', 'resources[limit]':'10'}).toString();
      const response = await fetch(url, {signal:request.signal, headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Search unavailable');
      const data = await response.json();
      if (current === generation) show(data.resources?.results?.products || [], query);
    } catch (error) {
      if (error.name === 'AbortError' || current !== generation) return;
      list.replaceChildren();
      status.textContent = 'Search is temporarily unavailable. Please try again.';
      results.hidden = false;
    }
  }
  searchDisclosure.addEventListener('toggle', () => {
    header?.classList.toggle('op6-search-active', searchDisclosure.open);
    trigger.setAttribute('aria-label', searchDisclosure.open ? 'Close search' : 'Search the library');
    if (searchDisclosure.open) input?.focus({preventScroll:true});
    else { request?.abort(); clearTimeout(timer); clearResults(); }
  });
  input?.addEventListener('input', () => {clearTimeout(timer); timer = setTimeout(search, 180);});
  form?.addEventListener('submit', event => {event.preventDefault(); clearTimeout(timer); search();});
  input?.addEventListener('keydown', event => {
    if (event.key === 'ArrowDown' && !results.hidden) {
      const first = list.querySelector('a');
      if (first) { event.preventDefault(); first.focus(); }
    }
  });
  list?.addEventListener('keydown', event => {
    if (event.key === 'ArrowUp') { event.preventDefault(); input.focus(); }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && searchDisclosure.open) { event.preventDefault(); close(); }
  });
  document.addEventListener('pointerdown', event => {
    if (searchDisclosure.open && !searchDisclosure.contains(event.target)) searchDisclosure.open = false;
  });
}
